// extracted by mini-css-extract-plugin
module.exports = {"container":"M-6eG1GtFq5FDNPRjP64"};